import api from '../api/axios';

export interface Warehouse {
  id?: number;
  name: string;
  code: string;
  address?: string;
  city?: string;
  country?: string;
  phone?: string;
  email?: string;
  manager?: number;
  capacity?: number;
  isActive?: boolean;
}

const WarehouseService = {
  getAll: (params?: any) => api.get('/warehouses', { params }),
  getOne: (id: number) => api.get(`/warehouses/${id}`, { params: { populate: '*' } }),
  create: (data: Warehouse) => api.post('/warehouses', { data }),
  update: (id: number, data: Partial<Warehouse>) => api.put(`/warehouses/${id}`, { data }),
  delete: (id: number) => api.delete(`/warehouses/${id}`),
};

export default WarehouseService;
